/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Proof_BlogInputs */

const en_cap_proof_blog = /** @type {(inputs: Cap_Proof_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content engine`)
};

const lv_cap_proof_blog = /** @type {(inputs: Cap_Proof_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satura sistēma`)
};

/**
* | output |
* | --- |
* | "Content engine" |
*
* @param {Cap_Proof_BlogInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_proof_blog = /** @type {((inputs?: Cap_Proof_BlogInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Proof_BlogInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_proof_blog(inputs)
	return en_cap_proof_blog(inputs)
});